<div class="container" *ngIf="!isLoading">
    <div class="search-bar-container">
        <app-channel-text-input
            class="search-input"
            [label]="'runnning-hour-group.search-input.placeholder' | translate"
            [value]="searchInput"
            icon="search"
            (onInputChange)="searchInput = $event.value; filterRunningHourGroups()" />
    </div>

    <div class="upper-content">
        <button
            class="incomplete-channels-button"
            (click)="getIncompleteRunningHourGroups()"
            [class.active]="isFilteringIncomplete">
            <mat-icon svgIcon="filter-list" class="filter-button-icon"></mat-icon>
            {{ 'running-hour-group.incomplete-channel-groups.filter.button' | translate }}
        </button>
        <div class="table-upper-text">
            {{ 'running-hour-group.channel-counter.text' | translate: { count: filteredRunningHourGroups.length } }}
        </div>
        <button class="auto-set-button" [disabled]=!userCanEdit (click)="autoSetDataSourceChannelsDialog()">
            <mat-icon svgIcon="auto" class="auto-set-button-icon"></mat-icon>
            {{ 'running-hour-group.auto-set.button' | translate }}
        </button>
    </div>

    <div class="table-wrapper" *ngIf="isShowTable">
        <div class="table-header">
            <div class="header-td group-id-header">
                {{ 'running-hour-group.page.table.header.channelName' | translate }}
            </div>
            <div class="header-td name-header">
                {{ 'running-hour-group.page.table.header.dataSource' | translate }}
            </div>
            <div class="header-td description-header">
                {{ 'running-hour-group.page.table.header.status' | translate }}
            </div>
        </div>
        <div class="table-content">
            <div class="table-data">
                <ng-container *ngIf="!isLoading">
                    <app-running-hour-row
                        class="table-row"
                        [canEdit]="userCanEdit"
                        *ngFor="let runningHourGroup of filteredRunningHourGroups"
                        [runningHourGroup]="runningHourGroup"
                        [dataSourceChannel]="dataSourceChannelMap.get(runningHourGroup.id)"
                        [runningHourChannel]="runningHourChannelMap.get(runningHourGroup.id)"
                        [vesselId]="vesselId"
                        [isDropdownOpen]="openRowIndex === runningHourGroup.id"
                        [configuredRunningHourGroups]="configuredRunningHourGroups"
                        (toggleDropdown)="toggleDropdown($event)"
                        (closed)="closeDropdown()"
                        (groupUpdated)="onGroupUpdated($event)"
                        (dataSourceChannelChanged)="onDataSourceChannelChanged($event)"></app-running-hour-row>
                </ng-container>
            </div>
        </div>
    </div>

    <div class="table-error-message-text" *ngIf="!isShowTable">
        {{ errorMessage }}
    </div>
</div>

<app-confirmation-window
    #autoSetConfirmation
    [mainLabel]="'running-hour-group.auto-set.confirmation'"
    [subLabel]="'running-hour-group.auto-set.confirmation.description'"
    [discardLabel]="'running-hour-group.auto-set.confirmation.cancel'"
    [saveLabel]="'running-hour-group.auto-set.confirmation.save'"
    [allButtonsLeft]="true"
    [inverseColors]="true">
</app-confirmation-window>

<div *ngIf="isLoading || isAutoSetting" class="loading-container">
    <app-loading-spinner [custom]="true" class="spinner-component" size="180" strokeWidth="20"></app-loading-spinner>
</div>
